import { ChildrenFilter, ScreenerFilterOption } from '@api';
import { DropdownMenu } from '@design/components/dropdown-menu/DropdownMenu';
import { DropdownEntry } from '@design/components/dropdown-menu/dropdown-group/DropdownGroup';
import { DropdownRadioGroup } from '@design/components/dropdown-menu/dropdown-radio-group/DropdownRadioGroup';
import { Icon } from '@design/components/icon/Icon';

import styles from './ChildFilterOptionDropdown.module.scss';

export const ChildFilterOptionDropdown = ({
  childFilter,
  selectedChildOption,
  setSelectedChildOption,
}: {
  childFilter: ChildrenFilter;
  selectedChildOption: ScreenerFilterOption;
  setSelectedChildOption: (option: ScreenerFilterOption) => void;
}) => {
  const dropdownItems: DropdownEntry[] = childFilter.options.map(opt => ({
    label: opt.description ?? opt.name,
    key: opt.key,
    onClick: () => setSelectedChildOption(opt),
  }));

  return (
    <DropdownMenu
      triggerNode={
        <div className={styles.childFilterDropdownTrigger}>
          {`(${selectedChildOption.name})`}
          <Icon
            iconName="ChevronBoldDown"
            size={12}
            fillColor="var(--icon-primary)"
            data-testid="child-filter-dropdown"
          />
        </div>
      }
    >
      <DropdownRadioGroup
        label={childFilter.name}
        items={dropdownItems}
        selectedKey={selectedChildOption.key}
      />
    </DropdownMenu>
  );
};
